import React, { useEffect, useState } from 'react';
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
} from 'react-icons/fa';
import logo from '../asset/logowhite.png';
import { FaFacebookF, FaInstagram, FaYoutube, FaXTwitter, FaWhatsapp } from 'react-icons/fa6';
import axios from 'axios';
import SummaryApi from '../common';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [trendyCourses, setTrendyCourses] = useState([]);
  const [careerCourses, setCareerCourses] = useState([]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios({
          url: SummaryApi.footercourses.url,
          method: SummaryApi.footercourses.method,
        });

        if (response.data.status && response.data.data) {
          const data = response.data.data;

          const trendy = data
            .filter(c => c.is_trendy_course === 1)
            .map(c => c.course_title)
            .slice(0, 5);

          const career = data
            .filter(c => c.is_career_course === 1)
            .map(c => c.course_title)
            .slice(0, 5);

          setTrendyCourses(trendy);
          setCareerCourses(career);
        }
      } catch (err) {
        console.error('Failed to load footer courses', err);
      }
    };

    fetchCourses();
  }, []);

  return (
    <footer className="bg-[#001f3f] dark:bg-[#111827] text-white px-6 md:px-20 py-12 text-sm border-t dark:border-gray-700">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-5 gap-10">
        {/* Column 1: About + Contact */}
        <div className="md:col-span-1">
          <img src={logo} alt='logo' className="h-10 mb-4 brightness-100 dark:brightness-100" />

          <p className="text-white dark:text-gray-300 mb-6">
            Skillara is a premium online training provider with the most effective learning system. We help professionals learn cutting-edge technologies for accelerated career growth.
          </p>

          <div className="text-white dark:text-gray-400 space-y-3">
            <p className="flex items-start">
              <FaMapMarkerAlt className="mt-1 mr-2 text-blue-300 dark:text-blue-400" />
              4th Floor, MKR Enclave, Kamayyathopu Pantakaluva Road, NTR Marg, Kanuru, Vijayawada, Andhra Pradesh 520007
            </p>
            <p className="flex items-center">
              <FaPhoneAlt className="mr-2 text-green-300 dark:text-green-400" />
              +1 833 564 3321 (Toll Free)
            </p>
            <p className="flex items-center">
              <FaEnvelope className="mr-2 text-purple-300 dark:text-purple-400" />
              contact@skillara.org
            </p>
          </div>
        </div>

        {/* Column 2: Trending Certification Courses */}
        <div>
          <h3 className="font-bold mb-4 border-b border-gray-300 dark:border-gray-300 inline-block pb-1 uppercase text-white dark:text-white">
            Trending Courses
          </h3>
          <ul className="text-white dark:text-gray-400 space-y-2">
            {trendyCourses.length > 0 ? (
              trendyCourses.map((course, idx) => (
                <li key={idx}>
                  <Link
                    to="/trendy-courses"
                    className="hover:text-gray-200 transition"
                  >
                    • {course}
                  </Link>
                </li>
              ))
            ) : (
              <li>• Loading...</li>
            )}
            {trendyCourses.length >= 5 && (
              <li>
                <Link
                  to="/trendy-courses"
                  className="text-white  font-medium transition"
                >
                  View More →
                </Link>
              </li>
            )}
          </ul>
        </div>

        {/* Column 3: Career Related Courses */}
        <div>
          <h3 className="font-bold mb-4 border-b border-gray-300 dark:border-gray-300 inline-block pb-1 uppercase text-white dark:text-white">
            Career Related Courses
          </h3>
          <ul className="text-white dark:text-gray-400 space-y-2">
            {careerCourses.length > 0 ? (
              careerCourses.map((course, idx) => (
                <li key={idx}>
                  <Link
                    to="/carrer-courses"
                    className="hover:text-gray-200 transition"
                  >
                    • {course}
                  </Link>
                </li>
              ))
            ) : (
              <li>• Loading...</li>
            )}
            {careerCourses.length >= 5 && (
              <li>
                <Link
                  to="/carrer-courses"
                             className="hover:text-gray-200 transition"
                >
                  View More →
                </Link>
              </li>
            )}
          </ul>
        </div>

        {/* Column 4: Company */}
        <div>
          <h3 className="font-bold mb-4 border-b border-gray-300 dark:border-gray-300 inline-block pb-1 uppercase text-white dark:text-white">
            Company
          </h3>
          <ul className="text-white dark:text-gray-400 space-y-2">
<li>
  <Link 
    to="/about" 
    className="hover:text-gray-200 transition"
    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
  >
    • About
  </Link>
</li>

            <li>• News & Media</li>
<li>
  <Link
    to="/#student-reviews"
    className="hover:text-gray-200 transition"
  >
    • Reviews
  </Link>
</li>
<li>
  <Link 
    to="/contact" 
    className="hover:text-gray-200 transition"
    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
  >
    • Contact Us
  </Link>
</li>
            <li>• Terms & Conditions</li>
            <li>• Privacy Policy</li>
          </ul>
        </div>

        {/* Column 5: Resources + Social */}
        <div>
          <h3 className="font-bold mb-4 border-b border-gray-300 dark:border-gray-300 inline-block pb-1 uppercase text-white dark:text-white">
            Resources
          </h3>
          <ul className="text-white dark:text-gray-400 space-y-2 mb-6">
<li>
  <Link
    to="/#blog"
    className="hover:text-gray-200 transition"
    
  >
    • Blog
  </Link>
</li>
            <li>
      <Link
        to="/resourses"
        className="hover:text-gray-200 transition"
           onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        • Community
      </Link>
    </li>
              <li>
      <Link
        to="/resourses"
        className="hover:text-gray-200 transition"
           onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        • Videos
      </Link>
    </li>
              <li>
      <Link
        to="/resourses"
        className="hover:text-gray-200 transition"
           onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        • Webinars
      </Link>
    </li>
          </ul>

          <h3 className="font-bold mb-2 uppercase text-white dark:text-white">Social Icons</h3>
          <p className="text-white dark:text-gray-400 text-sm mb-3">Follow us on</p>

          <div className="flex gap-4 text-white dark:text-gray-400 text-xl">
            <a href="#" className="hover:text-gray-200 dark:hover:text-white transition" aria-label="Facebook">
              <FaFacebookF />
            </a>
            <a href="#" className="hover:text-gray-200 dark:hover:text-white transition" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="#" className="hover:text-gray-200 dark:hover:text-white transition" aria-label="YouTube">
              <FaYoutube />
            </a>
            <a href="#" className="hover:text-gray-200 dark:hover:text-white transition" aria-label="Twitter">
              <FaXTwitter />
            </a>
            <a href="#" className="hover:text-gray-200 dark:hover:text-white transition" aria-label="WhatsApp">
              <FaWhatsapp />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;